// instructionShowHide.js - JS to show/hide instructions
// Copyright (C) 2020 Saxton Technical Event Solutions

document.addEventListener('DOMContentLoaded', (event) => {
  const instructionButton = document.getElementById('instructionButton');
  const instructionContainer = document.getElementById('instructionContainer');
  const toggleHandler = () => {
    switch (instructionContainer.style.visibility) {
      case 'hidden':
        instructionContainer.style.visibility = 'visible';
        break;
      default:
        instructionContainer.style.visibility = 'hidden';
    }
  };
  if (instructionButton && instructionContainer) {
    instructionButton.addEventListener('click',  toggleHandler);
    instructionContainer.addEventListener('click',  toggleHandler);
  }
});
